import React from 'react';
import {useSelector} from 'react-redux';
import {Box, Container, useMediaQuery, useTheme} from '@mui/material';
import Loading from '../../common/components/Loading';
import PlanSelection from './PlanSelection';
import AthleteCounts from './AthleteCounts';
import SubscriptionPlanError from './SubscriptionPlanError';
import HighlighterHeader, {HighlighterBackground} from './HighlighterHeader';
import {SubscriptionOption, SubscriptionOptionsResponse} from '../types';

interface Props {
    handlePaymentPreview: (plan: SubscriptionOption) => Promise<void>;
    handleDowngrade: () => Promise<void>;
    subscriptionOptions: SubscriptionOptionsResponse;
    currentPlan: SubscriptionOption;
    selectedPlan: SubscriptionOption;
    setSelectedPlan: (plan: SubscriptionOption) => void;
    hasErrorLoadingOptions: boolean;
    setHasErrorLoadingOptions: (hasError: boolean) => void;
    isLoading: boolean;
}

export default function PlanSelectionPage({
                                              handlePaymentPreview,
                                              handleDowngrade,
                                              subscriptionOptions,
                                              currentPlan,
                                              selectedPlan,
                                              setSelectedPlan,
                                              hasErrorLoadingOptions,
                                              setHasErrorLoadingOptions,
                                              isLoading
                                          }: Props) {
    const isHeadCoach = useSelector((state: any) => state.user.headCoach);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (isLoading) {
        return <Loading/>;
    }

    const {athleteCount, invitedAthleteCount, coachCount} = subscriptionOptions;

    return (
        <>
            <Box display="flex" flexDirection="column">
                <Container maxWidth="lg">
                    <HighlighterHeader
                        title="Plans for every coach"
                        highlighterBackground={HighlighterBackground.UPGRADE}
                        width={isSmallScreen ? 315 : 398}
                    />
                    <Box className="current-plan-info">
                        <PlanSelection
                            subscriptionOptions={subscriptionOptions}
                            currentPlan={currentPlan}
                            selectedPlan={selectedPlan}
                            handlePaymentPreview={handlePaymentPreview}
                            handleDowngrade={handleDowngrade}
                            setSelectedPlan={setSelectedPlan}
                        />
                        <AthleteCounts
                            currentAthletes={athleteCount}
                            invitedAthletes={invitedAthleteCount}
                            coachCount={coachCount}
                        />
                    </Box>
                </Container>
            </Box>
            <SubscriptionPlanError open={hasErrorLoadingOptions} handleClose={() => setHasErrorLoadingOptions(false)}/>

        </>
    );
}
